import React from 'react';
import './ServicePage.css';

const PrivateHealth = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>💊 Özel Sağlık Sigortası</h1>
          <p>Özel sağlık sigortası ile kaliteli sağlık hizmeti</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>Özel Sağlık Sigortası Nedir?</h2>
            <p>
              Özel sağlık sigortası, SGK'dan bağımsız olarak özel hastanelerde 
              tedavi görmenizi sağlayan sigorta türüdür. Geniş kapsamlı sağlık 
              hizmetleri sunar ve kaliteli sağlık hizmetine erişim sağlar.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>Özel hastane muayeneleri</li>
              <li>Ameliyat ve cerrahi müdahaleler</li>
              <li>Yatarak tedavi</li>
              <li>İlaç giderleri</li>
              <li>Tahlil ve tetkikler</li>
              <li>Check-up paketleri</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>Kaliteli sağlık hizmeti</li>
              <li>Geniş hastane ağı</li>
              <li>Bekleme süresi yok</li>
              <li>Esnek paket seçenekleri</li>
              <li>Aile paketleri</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivateHealth;

